import React from 'react';
import './ChatbotFab.css';

const ChatbotFab = ({ isOpen, onToggle }) => {
  return (
    <button
      type="button"
      className={`chatbot-fab ${isOpen ? 'chatbot-fab-open' : ''}`}
      aria-label={isOpen ? 'Close chat' : 'Open chat'}
      title={isOpen ? 'Close chat' : 'Chat with us'}
      onClick={onToggle}
    >
      <span className="chatbot-fab-icon" aria-hidden="true">
        <svg
          className="chatbot-fab-gear"
          width="64"
          height="64"
          viewBox="0 0 24 24"
          focusable="false"
        >
          <path
            fill="currentColor"
            d="M19.14 12.94c.04-.31.06-.63.06-.94s-.02-.63-.06-.94l2.03-1.58a.5.5 0 0 0 .12-.61l-1.92-3.32a.5.5 0 0 0-.59-.2l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54A.5.5 0 0 0 14.5 2h-5a.5.5 0 0 0-.48.41l-.36 2.54c-.59.24-1.13.56-1.62.94l-2.39-.96a.5.5 0 0 0-.59.2L2.14 8.87a.5.5 0 0 0 .12.61l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58a.5.5 0 0 0-.12.61l1.92 3.32c.12.21.37.28.59.2l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54a.5.5 0 0 0 .48.41h5a.5.5 0 0 0 .48-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47.01.59-.2l1.92-3.32a.5.5 0 0 0-.12-.61l-2.03-1.58ZM12 15.5c-1.93 0-3.5-1.57-3.5-3.5S10.07 8.5 12 8.5s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5Z"
          />
        </svg>
        <span className="chatbot-fab-gear-center" aria-hidden="true" />
        <svg
          className="chatbot-fab-msg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          focusable="false"
        >
          <path
            fill="currentColor"
            d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"
          />
        </svg>
      </span>
    </button>
  );
};

export default ChatbotFab;
